var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{class:[_vm.isDark ? 'dark-chip-col' : ''],attrs:{"color":_vm.getColor(_vm.value)}},[_vm._v("\n    "+_vm._s(_vm.value)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }